/** A build as Brandon names it: "Release 2026-10-26 16:52" (Mountain Time), the short commit hash muted
 *  after it, the full hash on hover. Local builds say "Local build". */
export function ReleaseLabel({ release, version, className }: { release?: string | null; version?: string | null; className?: string }) {
  const hash = version && version !== "dev" ? version : "";
  const named = !!release && release !== "dev";
  return (
    <span className={className ?? "text-xs"}>
      {named ? `Release ${release}` : hash ? "Build" : "Local build"}
      {hash && (
        <span className="num ml-1.5 text-[var(--color-muted-foreground)]" title={`Commit ${hash}`}>
          {hash.slice(0, 7)}
        </span>
      )}
    </span>
  );
}

/** The same in one line of text, for hover titles: "Release 2026-10-26 16:52, commit abc…", "Commit abc…" or "Local build". */
export function releaseText(release?: string | null, version?: string | null): string {
  const hash = version && version !== "dev" ? version : "";
  if (release && release !== "dev") return `Release ${release}${hash ? `, commit ${hash}` : ""}`;
  return hash ? `Commit ${hash}` : "Local build";
}
